import { useEffect } from 'react';
import { BackHandler } from 'react-native';
import { Stack } from 'expo-router/stack';
import { useTheme } from '@/contexts/ThemeContext';

export default function OnboardingLayout() {
  const { theme } = useTheme();

  // Block Android hardware back button during onboarding
  useEffect(() => {
    const sub = BackHandler.addEventListener('hardwareBackPress', () => true);
    return () => sub.remove();
  }, []);

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: theme.colors.background },
        animation: 'slide_from_right',
        gestureEnabled: false,
        headerBackVisible: false,
      }}>
      <Stack.Screen name="home-gym" />
      <Stack.Screen name="handle" />
      <Stack.Screen name="choose-path" />
      <Stack.Screen name="quick-profile" />
      <Stack.Screen name="baseline" />
      <Stack.Screen name="terms-accept" />
      <Stack.Screen name="score-reveal" />
      {/* Phase 2E: Minor compliance screens */}
      <Stack.Screen name="age-blocked" options={{ gestureEnabled: false }} />
      <Stack.Screen name="guardian-consent" options={{ gestureEnabled: false }} />
    </Stack>
  );
}
